"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uppercase = (str) => String(str).toUpperCase();
exports.default = uppercase;
//# sourceMappingURL=uppercase.js.map